import styled, { css } from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const TooltipBubbleContainer = styled.div`
  position: absolute;
  top: 0;
  left: ${({ rightOffset, leftOffset }) => `calc(65% - ${rightOffset}px + ${leftOffset}px)`};
  z-index: 99999;

  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  padding: 8px;

  color: ${getToken('color-neutral-white')};
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  text-align: center;

  background-color: ${getToken('color-neutral-dark')};
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  opacity: 0;

  transition: opacity 150ms linear;

  pointer-events: none;

  &::after {
    position: absolute;
    left: ${({ rightOffset, leftOffset }) =>
      `calc(50% + ${rightOffset}px - ${leftOffset}px - 6px)`};

    width: 12px;
    height: 12px;

    background-color: ${getToken('color-neutral-dark')};
    transform: rotate(45deg);

    content: '';
  }
`

/**
 * Wrapper
 */

const aboveStyle = css`
  & > ${TooltipBubbleContainer} {
    transform: translateX(-50%) translateY(calc(-100% - 7px));
    &::after {
      bottom: -3px;
    }
  }
`

const belowStyle = css`
  & > ${TooltipBubbleContainer} {
    transform: translateX(-50%) translateY(calc(50% + 7px));
    &::after {
      top: -3px;
    }
  }
`

export const TooltipContainer = styled.div`
  display: inline-flex;
  height: 100%;

  position: relative;

  width: auto;

  text-transform: none;

  &:hover,
  &:focus,
  &:active {
    & > ${TooltipBubbleContainer} {
      opacity: 1;

      pointer-events: auto;
    }
  }

  ${({ below }) => (below ? belowStyle : aboveStyle)};
`
